import React from 'react';
import styles from './style.module.css';
import SummaryForm from '../../components/forms/summary';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Summary of your Prosperity Plan</h1>
        <p className={styles.text}>Take a look at your response below. Did you capture everything you wanted to? Feel free to make any changes before completing the planner.</p>
        <SummaryForm/>
    </div>
);
